import React, { Component } from 'react';
import { Localization } from '../../Common/Localization';
import { config } from '../../Config/Config';
import {Box} from "@mui/material";

const styles = {
  container: {
    borderRadius: '12px',
    width: '96%',
    maxWidth: '360px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
};

class EllipseButton extends Component {
  constructor() {
    super();

    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    if (!this.props.isDisabled) {
      this.props.onClick();
    }
  }

  render() {
    const containerStyle = {
      ...styles.container,
      ...config.theme.saveButtonStyle,
      ...(this.props.isDisabled ? {
        cursor: 'default',
        ...config.theme.saveButtonDisableStyle,
      } : undefined),
    };

    const labelStyle = {
      userSelect: 'none',
      ...config.theme.saveButtonLabel,
    };

    const enabledLabelStyle = {
        ...labelStyle,
        color: config.theme.saveButtonLabelEnabled?.color || config.theme.saveButtonLabel.color ,
    }

    return (
      <Box disabled={this.props.isDisabled} sx={containerStyle} onClick={this.onClick}>
        <Box sx={this.props.isDisabled ?labelStyle: enabledLabelStyle}>{Localization.SUBMIT_BUTTON_TEXT}</Box>
      </Box>
    );
  }
}

export default EllipseButton;
